import { render, staticRenderFns } from "./HappyApp.vue?vue&type=template&id=572d45ff&"
import script from "./HappyApp.vue?vue&type=script&lang=js&"
export * from "./HappyApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports